import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";

import { CustomDatePicker, ErrorMessage } from "../index";

export const Datepicker = ({ label, name, errorMessage, control, errors }) => {
  return (
    <div className="input_holder">
      <label>{label}</label>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <DatePicker
            onChange={onChange}
            selected={value}
            customInput={<CustomDatePicker />}
            // The calendar renders at the document root, not inside the field.
            // As a child it was clipped by the card (.card has overflow:hidden
            // for its rounded corners, .card-body has overflow:auto), leaving a
            // sliver below the input that could not be read or clicked.
            // `popperProps.strategy: "fixed"` did not help -- react-datepicker
            // 4.8 kept the popper absolutely positioned, so it stayed inside
            // the clipping ancestors. A portal leaves them entirely.
            portalId="datepicker-portal"
            popperPlacement="bottom-start"
          />
        )}
      />
      {errors && errors[name] && <ErrorMessage text={errorMessage} />}
    </div>
  );
};

export default Datepicker;
